// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"A3-z","disabled":"B3-z","seeAllAnswers":"C3-z"};